import script from "./PathModal.vue?vue&type=script&setup=true&lang=js"
export * from "./PathModal.vue?vue&type=script&setup=true&lang=js"

import "./PathModal.vue?vue&type=style&index=0&id=cb6a275e&lang=css"

const __exports__ = script;

export default __exports__